
<script>

import { mapGetters, mapActions } from "vuex";
import _system from '../../../../libs/system';
import iziToast from 'izitoast'
import 'izitoast/dist/css/iziToast.min.css';

  const countries = [
    'Searched on Google',
    'Referred by a friend',
    'Social Media',
    'Product Hunt',
    'Social Media Examiner',
    'Other'
  ]

   export default {
   name: "popupsAlertsSourceAndTitle",
   data() {
      return {
        title: '',
        source: ''
      }
   },
   computed: {
      ...mapGetters('session', ['isLoggedIn', 'getUser', 'getRole', 'getUserDb']),
      ...mapGetters("htmlModals", ["modals"]),
   },
   methods: {
      ...mapActions("htmlModals", ["setSourceTitleRequest"]),
      submit() {
         if(this.getRole.name == 'Admin' && (!this.title.length || !this.source.length)){
            return alert('Could you please provide the required fields? It helps a lot to provide better solution to you! Thank you :)');
         }
         if(this.getRole.name != 'Admin' && !this.title.length){
            return alert('Could you please provide the required fields? It helps a lot to provide better solution to you! Thank you :)');
         }
         let payload = {
            body: {
               title: this.title,
               source: this.source
            },
            query: {
               userId: this.getUser._id
            }
         }
         _system.services.user.updateUserProperties(payload, (err,res) => {
            if (err) return console.log(res);
            iziToast.success({
                  position: 'bottomCenter',
                  title: 'Thank you 🙏',
            });
            this.setSourceTitleRequest(false);

         });
      }
   },
   mounted(){},
   created(){}
}

</script>

<template>
<div class="modalWrapper">
<div class="modal"> </div>
<div style="margin-top: 15px;margin-bottom: 30px;"  class="ui container">

<div  class="ui grid centered stackable">
   <div class="ten wide column" >
      <div style="padding: 0;" @click="setConnectionError(false)"  class="ui basic segment right aligned">
<!--       <a style="background: rgba(0,0,0,0.6); position:relative; z-index:9999" class="ui black mini button">
      Close [ESC]</a> -->
      </div>
   </div>
</div>

   <div class="ui grid">
   <div style="background: #f1f1f1; border-radius: 0.5rem;" class="ten wide column centered">
      <div class="ui basic big segment">
         <div class="ui grid">
            <div class="sixteen wide column">
                <p>Hello! Our marketing team needs your help!</p>
                <div class="ui large form">
                    <div class="field">
                      <h2>What's your job title?</h2>
                      <input type="text" v-model="title" placeholder="Ex: Customer Success Manager">
                    </div>
                    <div v-if="getRole.name == 'Admin'" class="field">
                      <h2>How did you find about Juphy?</h2>
                      <input type="text" v-model="source" placeholder="Ex: Social Media, Blog, G2.com, Referred by a friend or I don't remember :(">
                    </div>
                    <div class="field">
                      <button @click="submit()" class="ui fluid green button"> Submit </button>
                    </div>
                </div>
            </div>
         </div>
        
      </div>
   </div>
   </div>

   </div>
</div>
</template>


<style scoped>

      .modalWrapper {
         position: fixed; 
         top: 0; 
         right: 0; 
         bottom: 0; 
         left:0; 
         z-index: 99999; 
         overflow-y: scroll;
         overflow-x: hidden;
      }
      .modalWrapper div {
         z-index: 99999;
      }
      .modal {
         position: fixed; 
         top: 0; 
         right: 0; 
         bottom: 0; 
         left:0; 
         background: rgba(41, 50, 84, 0.738) none repeat scroll 0% 0%; 
         z-index: 9999; 
         overflow-y: scroll;
         overflow-x: hidden;
      }
</style>





// WEBPACK FOOTER //
// src/components/dashboard/popups/alerts/sourceAndTitle.vue